import React, {useState, useRef} from 'react'
import {Button, Calendar} from "antd";
import esES from 'antd/lib/date-picker/locale/es_ES';
import 'moment/locale/es';
import {Field} from "./index";
import moment from "moment";
import {FieldBase} from "./components/FieldBase";

// rc-picker busca 'es_ES' en moment pero moment solo tiene 'es' (con lunes como primer día).
// Parcheamos el locale para que apunte a 'es'.
const esLocale = { ...esES, lang: { ...esES.lang, locale: 'es' } };

const toMomentArray = (val) => {
  if (!val) return [];
  if (Array.isArray(val)) return val.filter(m => moment.isMoment(m) && m.isValid());
  if (typeof val === 'string') {
    return val.split(',').filter(Boolean).map(d => {
      let m = moment(d, 'DD/MM/YYYY', true);
      if (!m.isValid()) m = moment(d, 'YYYY-MM-DD', true);
      return m;
    }).filter(m => m.isValid());
  }
  return [];
};

export class FieldMultiDate extends Field {

  constructor(obj = {}) {
    super(obj);
  }

  getComponent(form) {
    const disabled = this.disabled;
    const locale = this.locale === 'es' ? esLocale : undefined;

    const MultiDateInput = ({ value, onChange }) => {
      const [calendarValue, setCalendarValue] = useState(moment());
      const isPanelChange = useRef(false);

      const selectedDates = toMomentArray(value).map(m => m.format('YYYY-MM-DD'));

      const handleSelect = (date) => {
        if (disabled) return;
        if (isPanelChange.current) {
          isPanelChange.current = false;
          return;
        }
        setCalendarValue(date);
        const dateStr = date.format('YYYY-MM-DD');
        const newDates = selectedDates.includes(dateStr)
          ? selectedDates.filter(d => d !== dateStr)
          : [...selectedDates, dateStr];
        const sorted = [...newDates].sort();
        onChange(sorted.length ? sorted.join(',') : null);
      };

      return (
        <div className="multidate-calendar">
          <Calendar
            fullscreen={false}
            locale={locale}
            value={calendarValue}
            onSelect={handleSelect}
            onPanelChange={(date) => { isPanelChange.current = true; setCalendarValue(date); }}
            dateFullCellRender={(current) => {
              const isSelected = selectedDates.includes(current.format('YYYY-MM-DD'));
              return (
                <div className={`ant-picker-cell-inner ant-picker-calendar-date${isSelected ? ' multidate-selected' : ''}`}>
                  <div className="ant-picker-calendar-date-value">{current.date()}</div>
                </div>
              );
            }}
          />
          {!disabled && (
            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '4px 8px 8px' }}>
              <Button size="small" onClick={() => onChange(null)}>Limpiar</Button>
            </div>
          )}
        </div>
      );
    };

    return () => (
      <FieldBase condition={this.condition} form={form} size={this.size} label={this.label} name={this.name} value={this.value} help={this.help} rules={this.rules}>
        <MultiDateInput />
      </FieldBase>
    );
  }

  transformToField = (data) => {
    this.name = data.name;
    this.label = data.label;
    this.type = data.type;
    this.size = data.size ?? this.size;
    this.value = data.value ?? data.defaultValue;
    this.condition = data.condition ?? true;
    this.disabled = data.disabled ?? false;
    this.locale = data.locale ?? 'es';
    this.help = data.help;
    this.rules = data.rules;
    return this;
  }

  // Entrada: "2024-01-15,2024-02-03"  →  Salida: [moment, moment]
  // Mismo doble-formato que Date.js (DD/MM/YYYY o YYYY-MM-DD)
  transformValueToField = (data) => {
    return data.split(',')
      .filter(Boolean)
      .map(d => {
        let m = moment(d, 'DD/MM/YYYY', true);
        if (!m.isValid()) m = moment(d, 'YYYY-MM-DD', true);
        return m;
      })
      .filter(m => m.isValid());
  }
}
